import { signOut } from "firebase/auth";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../utils/fireBase";
import { addUser, removeUser } from "../utils/userSlice";
import { toggleGptSearchView, clearSuggestionPage } from "../utils/gptSlice";
import { changeLanguage } from "../utils/configSlice";
import logo from "../icons/aimax-high-resolution-logo-transparent.png";
import SEARCH_ICON from "../icons/icons8-search.svg";
import useMovieGenreIds from "../hooks/useMovieGenreIds";
import useNowPlayingMovies from "../hooks/useNowPlayingMovies";
import useTopRatedMovies from "../hooks/useTopRatedMovies";
import usePopularMovies from "../hooks/usePopularMovies";
import useTrendingMovies from "../hooks/useTrendingMovies";

const Header = () => {
  // console.log("header");

  useNowPlayingMovies();
  useTopRatedMovies();
  usePopularMovies();
  useMovieGenreIds();
  useTrendingMovies();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const langSelect = useRef(null);
  const user = useSelector((store) => store.user);

  const handleSignOut = () => {
    signOut(auth)
      .then(() => {
        // Sign-out successful.
      })
      .catch((error) => {
        // An error happened.
        navigate("/error");
      });
  };
  const handleGptSearchClick = () => {
    // Toggle GPT Search
    dispatch(toggleGptSearchView());
    dispatch(clearSuggestionPage());
  };

  const handleLanguageChange = () => {
    dispatch(changeLanguage(langSelect.current.value));
  };
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/auth.user
        const { uid, email, displayName } = user;
        dispatch(addUser({ uid: uid, email: email, displayName: displayName }));
        // navigate("/browse");
      } else {
        // User is signed out
        dispatch(removeUser());
        // dispatch(clearTrailerVideo());
        navigate("/");
      }
    });

    //Unsubscribe when component unmounts
    return () => unsubscribe();
  }, []);

  const handleExplore = () => {
    navigate("/explore");
  };

  const handleAisearch = () => {
    navigate("/aisearch");
  };
  return (
    <div className="absolute w-full bg-gradient-to-b from-[#060730] z-10 flex flex-row justify-between items-center  px-6 py-4 font-poppins ">
      {/* flex-col md: */}
      <Link to={"/"}>
        <img src={logo} alt="" className="w-28 sm:w-48 mx-auto md:mx-0" />
      </Link>
      {user && (
        <div className="flex gap-4 items-center text-white mx-auto md:m-0 ">
          <Link to={"/explore"}>
            <button onClick={handleExplore}>
              <img src={SEARCH_ICON} alt="search--v1" className="w-8" />
            </button>
          </Link>

          <button
            className="btn w-20 sm:w-28 font-normal sm:font-semibold  text-white text-xs sm:text-base bg-gradient-to-r from-[#6ee2f5] via-50% via-violet-600 to-blue-800 rounded-full hover:scale-105 ease-in-out duration-500 border-none"
            onClick={handleAisearch}
          >
            aisearch
          </button>
          <button
     
            className="btn w-22 sm:w-28 font-normal sm:font-semibold  text-white text-xs sm:text-base bg-gradient-to-r from-[#6ee2f5] via-50% via-violet-600 to-blue-800 rounded-full hover:scale-105 ease-in-out duration-500 border-none"
            onClick={handleSignOut}
          >
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default Header;
